// Open desktop dropdown menus on hover; click and keyboard still work.
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  var closeTimer;

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = '1';
      var details = menu.querySelector('details');
      var summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        closeTimer = setTimeout(function () {
          if (!menu.contains(document.activeElement) || document.activeElement === summary) details.removeAttribute('open');
        }, 150);
      });

      // Mouse click on the title should not close a hover-opened menu (keyboard Enter has detail === 0).
      summary.addEventListener('click', function (e) {
        if (mq.matches && e.detail > 0) e.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
